export const SEARCH_DEFAULT_TARGET = 'collectables';
